import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { RestMessage } from '@app/core/types';
import { CodeVerificationDTO } from '@app/core/types/user';
import { ToastService } from '@app/shared/services/toast/toast.service';

@Component({
  selector: 'app-recovery-code',
  templateUrl: './recovery-code.component.html',
  styleUrls: ['./recovery-code.component.sass'],
})
export class RecoveryCodeComponent implements OnInit {
  user: any = {};
  code: string;
  error: string;
  isError: boolean = false;
  submitted: boolean;
  codeVerification: CodeVerificationDTO;
  response: any;

  isSubmit: boolean = false;
  imagePath: any = undefined;
  tenant: any = undefined;
  clientId: any = null;
  userId: any = null;
  isEmailSent: boolean = false;

  constructor(
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private cdf: ChangeDetectorRef,
    private router: Router,
    private toastService: ToastService
  ) {
    this.code = '-------';
  }

  ngOnInit(): void {
    let authData = JSON.parse(localStorage.getItem('authorizationData'));
    if (authData) {
      this.code = authData.RecoveryCode;
    }
  }

  onContinue() {
    this.router.navigate(['/']);
  }
}
